import { render, staticRenderFns } from "./BasicVideoPlayer.vue?vue&type=template&id=715e5bed&scoped=true&"
import script from "./BasicVideoPlayer.vue?vue&type=script&lang=ts&"
export * from "./BasicVideoPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./BasicVideoPlayer.vue?vue&type=style&index=0&id=715e5bed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715e5bed",
  null
  
)

export default component.exports